<script>
const generateTempKey = () => `tmp-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

const emptyRedirect = () => ({
  id: null,
  tempKey: generateTempKey(),
  old_url: '',
  new_url: ''
})

export default {
  name: 'RedirectsList',
  components: {
    Action: () => import('@/components/general/Action'),
    Icon: () => import('@/components/general/Icon'),
    InputField: () => import('@/components/general/InputField')
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },

    validation: {
      type: Object,
      default: () => ({})
    },

    duplicateIndexes: {
      type: Array,
      default: () => []
    },

    maxUrl: {
      type: Number,
      default: 500
    },

    destination: {
      type: String,
      default: ''
    }
  },

  methods: {
    fieldValidation (index) {
      const each = this.validation && this.validation.$each

      return each ? each[index].old_url : {}
    },

    isDuplicate (index) {
      return this.duplicateIndexes.indexOf(index) > -1
    },

    add () {
      this.$emit('input', [
        ...this.items,
        emptyRedirect()
      ])
    },

    remove (index) {
      const next = this.items.slice()

      next.splice(index, 1)
      this.$emit('input', next)
    },

    onOldUrlInput (index, value) {
      const next = this.items.map((item, i) => (i === index
        ? {
          ...item,
          old_url: value
        }
        : item))

      this.$emit('input', next)
    }
  }
}
</script>

<template>
  <div>
    <div
      v-for="(item, index) in items"
      :key="item.id || item.tempKey || index"
      class="article-redirect-item"
    >
      <div class="article-redirect-item-header">
        <span class="article-redirect-item-number">
          {{ $t('articles.form:redirect.item', { number: index + 1 }) }}
        </span>
        <button
          type="button"
          class="article-redirect-item-remove"
          :aria-label="$t('articles.form:redirect.remove')"
          @click="remove(index)"
        >
          <Icon name="delete" />
        </button>
      </div>

      <InputField
        :label="$t('articles.form:redirect.old_url')"
        :value="item.old_url"
        :validation="fieldValidation(index)"
        :counter="maxUrl"
        @input="(value) => onOldUrlInput(index, value)"
      />

      <p
        v-if="isDuplicate(index)"
        class="article-input-error"
      >
        {{ $t('articles.form:redirect.duplicated') }}
      </p>

      <p
        v-if="destination"
        class="article-redirect-target"
      >
        {{ $t('articles.form:redirect.new_url', { url: destination }) }}
      </p>
    </div>

    <Action
      type="button"
      flat
      icon="add"
      :text="$t('articles.form:redirect.add')"
      @click="add"
    />
  </div>
</template>
